import {
  CapacityIconBanquet,
  CapacityIconCabaret,
  CapacityIconCentralTable,
  CapacityIconTableU,
  CapacityIconClassroom,
  CapacityIconCoctail,
  CapacityIconTheatre,
} from "assets/icons/spacePageIcons/svgAsComponentExports";

export const getDispositionTypeByKey = (key, t) => {
  const dispositionTypes = [
    {
      keyByName: "central",
      key: "1",
      Icon: CapacityIconCentralTable,
      name: t("booking.disposition.central"),
    },
    {
      keyByName: "U",
      key: "2",
      Icon: CapacityIconTableU,
      name: t("booking.disposition.U"),
    },
    {
      keyByName: "theatre",
      key: "3",
      Icon: CapacityIconTheatre,
      name: t("booking.disposition.theatre"),
    },
    {
      keyByName: "classe",
      key: "4",
      Icon: CapacityIconClassroom,
      name: t("booking.disposition.classe"),
    },
    {
      keyByName: "cocktail",
      key: "5",
      Icon: CapacityIconCoctail,
      name: t("booking.disposition.cocktail"),
    },
    {
      keyByName: "cabaret",
      key: "6",
      Icon: CapacityIconCabaret,
      name: t("booking.disposition.cabaret"),
    },
    {
      keyByName: "banquet",
      key: "7",
      Icon: CapacityIconBanquet,
      name: t("booking.disposition.banquet"),
    },
  ];
  return dispositionTypes.find((type) => type.key === key) || null;
};

export const getDispositionTypes = (t, space) => {
  const dispositionTypes = [
    {
      keyByName: "central",
      key: "1",
      key2: "type_1_people",
      count: space?.type_1_people,
      Icon: CapacityIconCentralTable,
      name: t("booking.disposition.central"),
    },
    {
      keyByName: "U",
      key: "2",
      key2: "type_2_people",
      count: space?.type_2_people,
      Icon: CapacityIconTableU,
      name: t("booking.disposition.U"),
    },
    {
      keyByName: "theatre",
      key: "3",
      key2: "type_3_people",
      count: space?.type_3_people,
      Icon: CapacityIconTheatre,
      name: t("booking.disposition.theatre"),
    },
    {
      keyByName: "classe",
      key: "4",
      key2: "type_4_people",
      count: space?.type_4_people,
      Icon: CapacityIconClassroom,
      name: t("booking.disposition.classe"),
    },
    {
      keyByName: "cocktail",
      key: "5",
      key2: "type_5_people",
      count: space?.type_5_people,
      Icon: CapacityIconCoctail,
      name: t("booking.disposition.cocktail"),
    },
    {
      keyByName: "cabaret",
      key: "6",
      key2: "type_6_people",
      count: space?.type_6_people,
      Icon: CapacityIconCabaret,
      name: t("booking.disposition.cabaret"),
    },
    {
      keyByName: "banquet",
      key: "7",
      key2: "type_7_people",
      count: space?.type_7_people,
      Icon: CapacityIconBanquet,
      name: t("banquet"),
    },
  ];

  return dispositionTypes;
};

export const getFilteredDispositionTypes = (space, t, capacity) => {
  const dispositionTypes = [
    {
      keyByName: "central",
      key: "1",
      count: space.type_1_people,
      Icon: CapacityIconCentralTable,
      name: t("booking.disposition.central"),
    },
    {
      keyByName: "U",
      key: "2",
      count: space.type_2_people,
      Icon: CapacityIconTableU,
      name: t("booking.disposition.U"),
    },
    {
      keyByName: "theatre",
      key: "3",
      count: space.type_3_people,
      Icon: CapacityIconTheatre,
      name: t("booking.disposition.theatre"),
    },
    {
      keyByName: "classe",
      key: "4",
      count: space.type_4_people,
      Icon: CapacityIconClassroom,
      name: t("booking.disposition.classe"),
    },
    {
      keyByName: "cocktail",
      key: "5",
      count: space.type_5_people,
      Icon: CapacityIconCoctail,
      name: t("booking.disposition.cocktail"),
    },
    {
      keyByName: "cabaret",
      key: "6",
      count: space.type_6_people,
      Icon: CapacityIconCabaret,
      name: t("booking.disposition.cabaret"),
    },
    {
      keyByName: "banquet",
      key: "7",
      count: space.type_7_people,
      Icon: CapacityIconBanquet,
      name: t("banquet"),
    },
  ];

  return dispositionTypes
    .filter(({ count }) => count > 0) // Keep only options with valid counts
    .map((type) => ({
      ...type,
      disabled: type.count < capacity, // Add 'disabled' property
    }));
};

export default getFilteredDispositionTypes;
